import { useMutation, useQueryClient } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import api from '@pray/shared/utils/api';

import type { ChatbotResponse, UnpublishChatbotParams } from './types';

export async function unpublishChatbot({ artistId }: UnpublishChatbotParams): Promise<ChatbotResponse> {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/chatbot/unpublish`;
  const response = await api.executePostRequest<ChatbotResponse>(url, {});

  return response.data;
}

export function useUnpublishChatbot() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: unpublishChatbot,
    onSuccess: (_, { artistId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.artistChatbot(artistId),
      });
    },
  });

  const { mutateAsync, ...rest } = mutation;

  return {
    unpublishChatbot: mutateAsync,
    ...rest,
  };
}
